import { gql } from '@apollo/client';

export default gql`
  mutation overridePrice($reference: String!, $items: [InputPriceItem]) {
    overridePrice(reference: $reference, items: $items) {
      reference
    }
  }
`;
